import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Query } from '@apollo/client/react/components';
import { Link } from 'react-router-dom';

import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import PanelPosts from 'four-nets/photoblog/panels/panel-posts';

import query, { PromoLoaderQuery, PromoLoaderQueryVariables } from './promo-posts.graphql';
import { PostType } from './promo-posts.graphql.types';
import defaultStyles from './promo-posts.scss';

export interface Props {
    styles: typeof defaultStyles;
}

const Panel: React.FC<{ data: PromoLoaderQuery | undefined }> = props => {
    const { data } = props;
    if (!data) {
        return null;
    }

    const feed = { edges: [{ node: data.firstPost }, { node: data.secondPost }].filter(item => item && item.node) };

    if (data.feed && data.feed.edges) {
        data.feed.edges
            .filter(edge => edge && edge.node && feed.edges.map(edge => edge?.node?.id).indexOf(edge.node.id) === -1)
            .forEach(edge => {
                if (edge) {
                    feed.edges.push(edge);
                }
            });
    }

    return <PanelPosts edges={feed.edges.slice(0, 5)} />;
};

class PromoPosts extends React.PureComponent<Props, {}> {
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.wrapper}>
                <div className={styles.title}>
                    <Link to='/blog/technikheluz/' className={styles.link}>
                        Galéria Heluz
                    </Link>
                </div>
                <Query<PromoLoaderQuery, PromoLoaderQueryVariables>
                    query={query}
                    variables={{
                        first: 5,
                        username: 'technikheluz',
                        postType: 'POST_ALBUM',
                        slug1: 'sidi-om7oah',
                        slug2: 'za-par-eur-v-chladku-ur61wb',
                    }}
                    notifyOnNetworkStatusChange={true}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading }) => {
                        const hasNoPosts = !data || !data.feed || !data.feed.edges || data.feed.edges.length <= 0;
                        if (!loading && hasNoPosts) {
                            return (
                                <div className={styles.noResults}>
                                    <FormattedMessage id='NO_RESULTS' />
                                </div>
                            );
                        }

                        return (
                            <LoadingWrapperView loading={loading}>
                                <Panel data={data} />
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </div>
        );
    }
}

export default Styled(defaultStyles)(PromoPosts);
